import * as React from "react";
import { observer } from "mobx-react";
import { TravelersField } from "components/shared/TravelersField";
import { TravelersProps } from "./typings";
import { travelersState } from "src/stores/wizard/state/global/travelers";
import { TravelersFieldConfig } from "src/stores/wizard/config";
import { travelersMetadata } from "../TravelersField/utils";
import { UitkLayoutGridItem } from "uitk-react-layout-grid";
import { useLocalization } from "@shared-ui/localization-context";

export const Travelers = observer((props: TravelersProps) => {
  if (props.hidden) {
    return null;
  }
  const { formatText } = useLocalization();

  const config: TravelersFieldConfig = props.config ? props.config : props.lobState.config.travelers;
  const travelers = !!props.lobState.travelers ? props.lobState.travelers : travelersState;
  const hotelTravelersInvalidKey = props.lobState.hotelTravelersInvalidKey
    ? formatText(props.lobState.hotelTravelersInvalidKey, config.maxBookableTravelers)
    : "";
  const nonHotelTravelersInvalidKey = props.lobState.nonHotelTravelersInvalidKey
    ? formatText(props.lobState.nonHotelTravelersInvalidKey, config.maxBookableTravelers)
    : "";
  const hotelPackageTravelersMetadata = props.lobState.hotelPackageTravelersMetadata
    ? props.lobState.hotelPackageTravelersMetadata
    : travelersMetadata(travelers.hotelPackage);

  const hotelTravelersMetadata = props.lobState.hotelTravelersMetadata
    ? props.lobState.hotelTravelersMetadata
    : travelersMetadata(travelers.hotel);

  const nonHotelTravelersMetadata = props.lobState.nonHotelTravelersMetadata
    ? props.lobState.nonHotelTravelersMetadata
    : travelersMetadata(travelers.nonHotel);

  return (
    <UitkLayoutGridItem colSpan={props.colSpan}>
      <div>
        <TravelersField
          travelers={
            config.withRooms && props.tripLobType
              ? travelers.hotelPackage
              : config.withRooms
              ? travelers.hotel
              : travelers.nonHotel
          }
          config={config}
          onSave={
            config.withRooms
              ? props.lobState.updateHotelTravelersSelection
              : props.lobState.updateNonHotelTravelersSelection
          }
          invalid={config.withRooms ? hotelTravelersInvalidKey : nonHotelTravelersInvalidKey}
          metadata={
            config.withRooms && props.tripLobType
              ? hotelPackageTravelersMetadata
              : config.withRooms
              ? hotelTravelersMetadata
              : nonHotelTravelersMetadata
          }
        />
      </div>
    </UitkLayoutGridItem>
  );
});
